var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FolderEmpty.tsx";
import React from 'react';
import { createSvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FolderEmpty = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.05",
    width: "24",
    height: "24",
    rx: "4",
    fill: "#00003D"
  }), /*#__PURE__*/_jsx("path", {
    opacity: "0.75",
    d: "M18 7.5H12L10.9425 6.4425C10.6575 6.1575 10.275 6 9.8775 6H6C5.175 6 4.5075 6.675 4.5075 7.5L4.5 16.5C4.5 17.325 5.175 18 6 18H18C18.825 18 19.5 17.325 19.5 16.5V9C19.5 8.175 18.825 7.5 18 7.5ZM17.25 16.5H6.75C6.3375 16.5 6 16.1625 6 15.75V9.75C6 9.3375 6.3375 9 6.75 9H17.25C17.6625 9 18 9.3375 18 9.75V15.75C18 16.1625 17.6625 16.5 17.25 16.5Z",
    fill: "#00003D"
  })]
}), 'FolderEmpty');